import { Button, ButtonProps } from '@chakra-ui/react';
import { ReactComponent as NewTabIcon } from 'assets/icons/new-tab.svg';
import { BRAND_REDIRECT_LINK } from 'constants/links';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

export const EditBrandKitButton = (props: Omit<ButtonProps, 'ref'>): ReactElement => {
  const { t } = useTranslation('editor_widget_menu', { useSuspense: false });
  return (
    <Button
      as='a'
      href={BRAND_REDIRECT_LINK}
      target='_blank'
      rel='noopener noreferrer'
      leftIcon={<NewTabIcon />}
      size='md'
      variant='outline'
      marginX={props.marginX ?? '4'}
      marginY={props.marginY ?? '3'}
      height={props.height ?? '10'}
      {...props}
    >
      {t('sideMenu.stylesMenu.editBrandKit')}
    </Button>
  );
};
